(function (root, factory) {
  const api = factory();

  root.normalizeRwadySearchQuery = api.normalizeRwadySearchQuery;
  root.RwadySearchNormalization = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const BRAND_REPLACEMENTS = [
    ['فيليبس', 'Philips'],
    ['فيلبس', 'Philips'],
    ['بيسل', 'Bissell'],
    ['كينوود', 'Kenwood'],
    ['تيفال', 'Tefal'],
    ['سامسونج', 'Samsung'],
  ];

  const cleanRwadySearchQuery = (query) => String(query ?? '').trim().replace(/\s+/g, ' ');

  const normalizeRwadySearchQuery = (query) => {
    let normalizedQuery = cleanRwadySearchQuery(query);
    if (typeof window !== 'undefined' && window.RwadyBrandAliases) {
      normalizedQuery = window.RwadyBrandAliases.normalizeQuery(normalizedQuery);
    }

    BRAND_REPLACEMENTS.forEach(([arabicName, shopifyName]) => {
      normalizedQuery = normalizedQuery.replaceAll(arabicName, shopifyName);
    });

    return normalizedQuery;
  };

  const createRwadySearchParams = (query) => {
    const originalQuery = cleanRwadySearchQuery(query);
    return {
      q: normalizeRwadySearchQuery(originalQuery),
      rwady_q: originalQuery,
    };
  };

  const normalizeRwadyBrandFilterTerm = (value) => {
    if (typeof window !== 'undefined' && window.RwadyBrandAliases) {
      value = window.RwadyBrandAliases.normalizeQuery(value);
    }
    let compact = String(value ?? '')
      .trim()
      .normalize('NFKD')
      .replace(/[\u064B-\u065F\u0670]/g, '')
      .replace(/[\s\-_.،,\/\\ـ]+/g, '')
      .toUpperCase();

    [
      ['فيليبس', 'PHILIPS'],
      ['فيلبس', 'PHILIPS'],
      ['بيسل', 'BISSELL'],
      ['كينوود', 'KENWOOD'],
      ['تيفال', 'TEFAL'],
      ['سامسونج', 'SAMSUNG'],
    ].forEach(([arabicName, englishName]) => {
      compact = compact.replaceAll(arabicName, englishName);
    });

    return compact;
  };

  const filterRwadyBrandNames = (names, query) => {
    const normalizedQuery = normalizeRwadyBrandFilterTerm(query);
    return names.filter((name) => normalizeRwadyBrandFilterTerm(name).includes(normalizedQuery));
  };

  const filterRwadyBrandBrowser = (input) => {
    const browser = input.closest('.rwady-brand-filter__browser');
    if (!browser) return 0;

    const term = normalizeRwadyBrandFilterTerm(input.value);
    const rows = Array.from(browser.querySelectorAll('[data-rwady-brand-row]'));
    let visibleCount = 0;

    rows.forEach((row) => {
      const matches = term === '' || normalizeRwadyBrandFilterTerm(row.dataset.rwadyBrandName).includes(term);
      row.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    const empty = browser.querySelector('[data-rwady-brand-empty]');
    const status = browser.querySelector('[data-rwady-brand-status]');
    if (empty) empty.hidden = visibleCount !== 0;
    if (status) status.textContent = visibleCount === 0 && empty ? empty.textContent.trim() : String(visibleCount);

    return visibleCount;
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-rwady-brand-search]');
      if (input) filterRwadyBrandBrowser(input);
    });
  }

  return {
    cleanRwadySearchQuery,
    normalizeRwadySearchQuery,
    createRwadySearchParams,
    normalizeRwadyBrandFilterTerm,
    filterRwadyBrandNames,
    filterRwadyBrandBrowser,
  };
});

